import { socialApiClient } from '@/shared/api-client/social-api-client';

export async function CheckCampaignName(
  workspaceId: string,
  name: string,
  signal?: AbortSignal,
): Promise<{
  available: boolean;
}> {
  const res = await socialApiClient.get(`workspaces/${workspaceId}/campaigns/name/availability`, {
    searchParams: {
      name,
    },
    signal,
  });
  return await res.json();
}
